// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".backstock-locations.dragging .backstock-locations-tbody-item{background-color:transparent!important;transition:background-color .7s ease-out}.backstock-locations.dragging .backstock-locations-tbody-item.dragged{background-color:#ffff9d!important;transition:background-color 0s}.backstock-locations .actions{width:120px}.backstock-locations .sorting{width:50px}.backstock-locations .v-list-item{padding-left:0}", ""]);
// Exports
module.exports = exports;
